import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../Components/Breadcrumb/Breadcrumb";
import axios from "axios";
import Cookies from "js-cookie";
import Modal from "react-bootstrap/Modal";
import EvnVar, { newEvn } from "../../../EnvVar";

function UploadEvent() {
    // js for modal
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    // js for modal

    const [triggerEffect, setTriggerEffect] = useState(false)
    const [imageTriggerEffect, setImageTriggerEffect] = useState(false)


    const baseurl = EvnVar();
    const domain_url = newEvn()
    const [eventData, setEventData] = useState([]);

    // Get Event Data API
    // Get API
    useEffect(() => {
        // To get Event data
        function getEventData() {
            const token = Cookies.get("jwt");
            let config = {
                method: "get",
                maxBodyLength: Infinity,
                url: `${baseurl}/dash/events`,
                headers: {
                    Authorization: token,
                },
                withCredentials: true,
            };

            axios
                .request(config)
                .then((response) => {
                    let result = JSON.stringify(response.data);
                    let data = JSON.parse(result);
                    setEventData(data);
                    // console.log("result", JSON.parse(result));
                })
                .catch((error) => {
                    console.log("Error fetching data:", error);
                });
            setTriggerEffect(false)
        }

        getEventData()

        // To get event image on popup
        function getEventImage() {
            const token = Cookies.get("jwt");
            let config = {
                method: "get",
                maxBodyLength: Infinity,
                url: `${baseurl}/dash/media`,
                headers: {
                    Authorization: token,
                },
                withCredentials: true,
            };

            axios.request(config)
                .then((response) => {
                    let mediaData = JSON.stringify(response.data)
                    let mediaJsonData = JSON.parse(mediaData)
                    // console.log("Media", mediaJsonData);
                    setMediaget(mediaJsonData)
                })
                .catch((error) => {
                    console.log(error);
                });
            setImageTriggerEffect(false)
        }
        getEventImage()
    }, [triggerEffect, imageTriggerEffect]);

    // Post API
    const [evntdata, setEvntData] = useState({
        name: "",
        date: "",
        time: "",
        venue: "",
        description: "",
    });

    const onChangeEvent = (e) => {
        const { id, value } = e.target
        const updatedFormData = {
            ...evntdata,
            [id]: value,
        }

        setEvntData(updatedFormData)
    }

    const eventSubmit = (e) => {
        e.preventDefault();
        const token = Cookies.get("jwt");
        // console.log('Form Data Submitted:', evntdata);
        // You can send formData to your server here

        let eventData = JSON.stringify(
            {
                "name": evntdata.name,
                "date": evntdata.date,
                "time": evntdata.time,
                "venue": evntdata.venue,
                "description": evntdata.description,
            }
        )

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseurl}/dash/events`,
            headers: {
                'content-type': 'application/json',
                Authorization: token,

            },
            data: eventData,
            withCredentials: true,
        }

        axios.request(config)
            .then((response) => {
                // console.log(JSON.stringify(response.data));
                setTriggerEffect(true)
            })
            .catch((error) => {
                console.log(error);
            });

    }


    // get all media API
    // js for modal
    const [showMedia, setShowMedia] = useState(false);
    const mediaClose = () => setShowMedia(false);
    const mediaShow = () => setShowMedia(true);
    // js for modal

    const [mediaget, setMediaget] = useState([])
    const [eventID, setEventID] = useState(null)
    const getMediaAPI = (e) => {
        // console.log("id.event", e.target.id);
        setEventID(e.target.id)
        const token = Cookies.get("jwt");
        let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `${baseurl}/dash/media`,
            headers: {
                Authorization: token,
            },
            withCredentials: true,
        };

        axios.request(config)
            .then((response) => {
                let mediaData = JSON.stringify(response.data)
                let mediaJsonData = JSON.parse(mediaData)
                // console.log("Media", mediaJsonData);
                setMediaget(mediaJsonData)
            })
            .catch((error) => {
                console.log(error);
            });
    }

    // image upload function
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const fileSelectedHandler = (event) => {
        const file = event.target.files[0];
        if(!file) return
        // console.log("file", file);
        setSelectedFile(file)

        // Generate a preview URL for the selected file
        const fileReader = new FileReader();
        fileReader.onload = () => {
            setPreviewUrl(fileReader.result);
        };
        fileReader.readAsDataURL(file);
    }

    const UploadImage = () => {
        // console.log("File selectedFile", selectedFile);
        const token = Cookies.get("jwt");
        if (!selectedFile) return;

        let formData = new FormData();
        formData.append('media', selectedFile);
        const uri = `${baseurl}/dash/media/${eventID}`;

        // console.log('uri ', uri);


        let config = {
            method: "post",
            maxBodyLength: Infinity,
            url: uri,
            headers: {
                'content-type': 'multipart/form-data',
                Authorization: token,
            },
            data: formData,
            withCredentials: true,
        };

        // console.log("|- Printing config for axios ", config, " -|")

        axios
            .request(config)
            .then((response) => {
                // console.log("|- response from server while uploading image ", JSON.stringify(response.data), " -|");
                setImageTriggerEffect(true)
                setSelectedFile(null)
                setPreviewUrl(null)
            })
            .catch((error) => {
                console.log("|- Error while uploading image ", error, " -|");
                if(error.response.status === 500){
                    alert("Please upload media in jpeg, jpg, png, gif, mp4, avi format!")
                }
            });

    }

    return (
        <>
            <Breadcrumb data="Upload Event" />
            <div className="content-body">
                <form>
                    <div className="table-data">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h5 className="mb-0">All Events</h5>
                            <button
                                type="button"
                                className="btn btn-warning download-btn"
                                variant="primary"
                                onClick={handleShow}
                            >
                                Add
                            </button>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Event Name</th>
                                        <th>Date</th>
                                        <th>Media</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {eventData && eventData.map((value, index) => {
                                        const isoDateString = value.date;
                                        const date = new Date(isoDateString);

                                        const options = {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric',
                                            hour: 'numeric',
                                            minute: 'numeric',
                                            second: 'numeric',
                                            hour12: true
                                        };

                                        const formattedDateTime = date.toLocaleString(undefined, options);
                                        return (
                                            <tr key={index}>
                                                <td>{value.name}</td>
                                                <td>{formattedDateTime}</td>
                                                <td><button type="button" className="download-btn" id={value.id} onClick={(e) => { mediaShow(); getMediaAPI(e); }}>Media</button></td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </form>
            </div>

            <Modal show={show} onHide={handleClose} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Upload Event</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={eventSubmit}>
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Event Name</th>
                                        <th>Date</th>
                                        <th>Time</th>
                                        <th>Venue</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <input
                                                required
                                                type="text"
                                                id="name"
                                                name="name"
                                                placeholder="Enter event name"
                                                onChange={onChangeEvent}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                required
                                                type="date"
                                                id="date"
                                                name="date"
                                                onChange={onChangeEvent}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                required
                                                type="time"
                                                id="time"
                                                name="time"
                                                onChange={onChangeEvent}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                required
                                                type="text"
                                                id="venue"
                                                name="venue"
                                                placeholder="Enter venue"
                                                onChange={onChangeEvent}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                required
                                                type="text"
                                                id="description"
                                                name="description"
                                                placeholder="Enter description"
                                                onChange={onChangeEvent}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <button type="submit" onClick={handleClose} className="download-btn d-flex ms-auto">
                            Save
                        </button>
                    </form>
                </Modal.Body>
            </Modal>


            <Modal show={showMedia} onHide={mediaClose} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Upload Image</Modal.Title>
                </Modal.Header>
                <Modal.Body className="upload-media">
                    <form>
                        <div className="row">
                            {mediaget && mediaget.length ? mediaget.map((value, index) => (
                                <div className="col-lg-2 mb-3" key={index} id={index}>
                                    <div className="w-100" style={{ backgroundColor: "#eee", borderRadius: "5px", padding: "5px", height: "200px", overflow: "hidden" }}>
                                        <img className="img-fluid object-fit-cover h-100 w-100" src={`${domain_url}${value.url}`} alt={value.event_id} style={{ objectPosition: "center" }} />
                                    </div>
                                </div>
                            )) : ""}
                            <div className="col-lg-2 mb-3">
                                <label htmlFor="addMedia" className="w-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: "#eee", borderRadius: "5px", padding: "5px", cursor: "pointer", height: "200px" }}>
                                    {previewUrl ? <img src={previewUrl} alt="Preview" style={{ objectPosition: "center" }} className="img-fluid object-fit-cover h-100 w-100" /> : <i className="fa-solid fa-plus" style={{ fontSize: "28px" }}></i>}
                                </label>
                                <input onChange={fileSelectedHandler} type="file" id="addMedia" className="d-none" />
                                {previewUrl && <button type="button" className="btn btn-warning d-flex ms-auto mt-2" onHide={mediaClose} onClick={() => { UploadImage(); }}>Upload</button>}
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default UploadEvent;
